import { ImportedRanking } from './ImportedRanking';

/**
 * Class representing a team imported ranking.
 * @extends ImportedRanking
 */
export class TeamImportedRanking extends ImportedRanking {}
